<template>
  <div>
    <div class="etablissement-entry-list">
      <etablissement-entry v-for="etablissement in chunks[pagination.pages.current - 1]"
                           :etablissement="etablissement"
                           :key="etablissement.id"></etablissement-entry>
    </div>
    <div class="text-center">
      <pagination v-if="pagination.entries.total > pagination.entries.per_page" :pagination="pagination"></pagination>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import EtablissementEntry from './EtablissementEntry.vue'
  import Pagination from './Pagination.vue'

  export default {

    components: {
      EtablissementEntry,
      Pagination
    },

    props: {
      etablissements: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        pagination: {
          entries: {
            total: 0,
            per_page: 0
          },
          pages: {
            current: 1,
            total: 1
          }
        }
      }
    },

    computed: {

      chunks () {
        return this.etablissements ? _.chunk(this.etablissements, this.pagination.entries.per_page) : []
      }

    },

    methods: {

      updatePagination (currentPage = 1) {
        this.pagination = {
          entries: {
            total: this.etablissements.length,
            per_page: 10
          },
          pages: {
            current: currentPage,
            total: Math.ceil(this.etablissements.length / 10)
          }
        }
      }

    },

    watch: {

      etablissements () {
        this.updatePagination()
      }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/etablissements/EtablissementsList.vue